import { useEffect, useState } from 'react';

import { IconButton } from '../../../cdl/IconButton/IconButton';
import { Input } from '../../../cdl/Input/Input';
import { translate } from '../../../common/helpers/translate.helper';
import { IconSearch } from '../../../common/icons/cdl/Search';
import { IconX } from '../../../common/icons/cdl/X';

interface FleetChangesSearchInputProps {
    onSearch: (value: string) => void;
    onClear: () => void;
}

export const FleetChangesSearchInput = ({ onSearch, onClear }: FleetChangesSearchInputProps) => {
    const [value, setValue] = useState('');

    useEffect(() => {
        if (!value) {
            return;
        }

        const timeout = setTimeout(() => onSearch(value), 300);
        return () => clearTimeout(timeout);
    }, [value, onSearch]);

    const updateValue = (nextValue: string) => {
        setValue(nextValue);
        if (!nextValue) {
            onClear();
        }
    };

    return (
        <Input
            aria-label={translate('placeholder.vessel.search')}
            placeholder={translate('placeholder.vessel.search')}
            leadingVisual={<IconSearch height={16} width={16} />}
            trailingVisual={
                value ? (
                    <IconButton
                        type="button"
                        Icon={IconX}
                        size="small"
                        emphasis="transparent"
                        aria-label={translate('demandDefinition.clearSearch')}
                        onClick={() => updateValue('')}
                    />
                ) : null
            }
            value={value}
            onChange={(event) => updateValue(event.target.value)}
        />
    );
};
